import { render, staticRenderFns } from "./EditLabel.vue?vue&type=template&id=3bc75277&scoped=true&"
import script from "./EditLabel.vue?vue&type=script&lang=js&"
export * from "./EditLabel.vue?vue&type=script&lang=js&"
import style0 from "./EditLabel.vue?vue&type=style&index=0&id=3bc75277&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc75277",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bc75277')) {
      api.createRecord('3bc75277', component.options)
    } else {
      api.reload('3bc75277', component.options)
    }
    module.hot.accept("./EditLabel.vue?vue&type=template&id=3bc75277&scoped=true&", function () {
      api.rerender('3bc75277', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/labels/EditLabel.vue"
export default component.exports